export type HouseAdProps = {
  headline: string;
  body: string;
  ctaHref?: string;
  ctaNode?: React.ReactNode;
  ctaText: string;
  featuredMedia: {
    altText: string | null;
    width: number;
    height: number;
    sourceUrl: string;
    srcSet: string;
  };
};

export enum TemplateType {
  HORIZONTAL = 'HORIZONTAL',
}
